/**
 * Client-side ShortlistGroup model with custom methods and computed properties
 */

import type { FirestoreContainer } from '#containers/FirestoreContainer.js';
import type { ClientInstanceOf } from '#firebase/types.js';

import { ShortlistGroupModelSpec } from '@elara/domain/models/ShortlistGroupModelSpec';

import { createClientModel } from '#firebase/createClientModel.js';

/**
 * ShortlistGroup model for client-side usage
 * Provides reactive access to shortlist group data with computed properties
 */
export function createClientShortlistGroupModel(firestore: FirestoreContainer) {
  const model = createClientModel(firestore, ShortlistGroupModelSpec, () => ({
    /** Display name for the shortlist group */
    get displayName(): string {
      return this.name || 'New shortlist';
    },
  }));

  return model;
}

export type ClientShortlistGroupModel = ReturnType<typeof createClientShortlistGroupModel>;
export type ShortlistGroup = ClientInstanceOf<ClientShortlistGroupModel>;
